import React, { useState } from 'react'
import { useDispatch, useStore, useSelector } from 'react-redux'

import {
  Space,
  Card,
  Table,
  Button,
  Input,
  Divider,
  Select,
  Collapse,
  Row,
  Col,
  AutoComplete,
  Modal,
  Form,
  message,
  Pagination,
  Switch,
  Tabs,
  Tag,
  Spin,
  DatePicker,
  Radio
} from 'antd'
import IntlMessages from '../../../util/IntlMessages'
import ds from '../../../Services/DataServices'
import Skeleton from 'react-loading-skeleton'
import ProductImg from '../../../assets/images/product-details.png'
import { useHistory } from 'react-router-dom'
import { faRecordVinyl } from '@fortawesome/free-solid-svg-icons'
import { cpuUsage } from 'process'
import { setCommonConfigs } from '../../../appRedux/actions/CommonData'
import { PRODUCT_SCREEN } from '../../../constants/Pages'
import {
  Area,
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  AreaChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
  ComposedChart,
  Line
} from 'recharts'

import Widget from '../../../components/Widget'
import Auxiliary from '../../../util/Auxiliary'
import SpecifiedDateRange from '../../../components/Reporting/SpecifiedDateRange'
import { verifyPkgFeature } from '../../../appRedux/actions'
import { PkgFeatures } from '../../../constants/StoreEntities'
import NotAllowedComponent from '../../../components/NotAllowedComponent'
const Panel = Collapse.Panel
const TabPane = Tabs.TabPane
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 24 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 24 }
  }
}

const viewByOptions = [
  { label: 'Day', value: 'Day' },
  { label: 'Week', value: 'Week' },
  { label: 'Month', value: 'Month ' }
]

const GiftCardReportsListing = ({ match }) => {
  const [form] = Form.useForm()
  const history = useHistory()
  const dispatch = useDispatch()
  const [visible, setVisible] = React.useState(false)
  const [isLoading, setIsLoading] = React.useState(true)
  const [getProductListingData, setProductListingData] = React.useState([])
  const [pagination, setPagination] = React.useState({
    CurrentPageNo: 1,
    PageSize: 10
  })
  const [options, setOptions] = useState([])
  const [getSearchProd, setSearchProd] = useState([])
  const [searchFilterData, setSearchFilterData] = React.useState({
    CurrentPageNo: 1,
    PageSize: 10
  })

  const [getCurrData, setCurrData] = useState({
    currencyCode: '',
    currencyName: '',
    currencySymbol: ''
  })

  const [getDefaultDecimalPlaces, setDefaultDecimalPlace] = React.useState(2) //api me isko db sy update rakhna hy
  const [isFeatureAllowed, setIsFeatureAllowed] = useState(true)
  //#region  for use Selector

  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )

  const getReduxStoreOutlets = useSelector(
    ({ Sell }) => Sell.openCloseStoreOutlets
  )

  //#endregion use Selector Region

  //#region  for use Effect
  React.useEffect(() => {
    getProductListing(pagination)
    if (!verifyPkgFeature(PkgFeatures.ReportingAndAnalytics)) {
      setIsFeatureAllowed(false)
    }
    //    getProductsData();
  }, [])

  //for common data -> store currency
  React.useEffect(() => {
    let commonData = getReduxCommonSetting
    if (
      commonData.storeCommonConfigs &&
      commonData.storeCommonConfigs.storeConfig &&
      commonData.storeCommonConfigs.storeConfig.currencyData
    ) {
      let currencyData = commonData.storeCommonConfigs.storeConfig.currencyData
      // setCurrSymbol(currencyData.currencySymbol);
      // setkShortCurr(currencyData.currencyCode);
      setCurrData(currencyData)
    }
  }, [getReduxCommonSetting])

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      if (Object.keys(getReduxCommonSetting).length === 0) {
        dispatch(setCommonConfigs(PRODUCT_SCREEN))
      }
    }

    return () => (mounted = false)
  }, [])

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      let commonData = getReduxCommonSetting
      if (
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig &&
        commonData.storeCommonConfigs.storeConfig.currencyData
      ) {
        let currencyData =
          commonData.storeCommonConfigs.storeConfig.currencyData
        // setCurrSymbol(currencyData.currencySymbol);
        // setShortCurr(currencyData.currencyCode);
        setCurrData(currencyData)
      }
    }

    return () => (mounted = false)
  }, [getReduxCommonSetting])
  //#endregion for use Effect

  function getRandomInt (max, min = 0) {
    return Math.floor(Math.random() * (max - min + 1)) + min // eslint-disable-line no-mixed-operators
  }

  async function getProductListing (searchObj) {
    await ds.getProductList(searchObj).then(types => {
      if (types.data.data != null) {
        let mapped = types.data.data.map(product => {
          return {
            key: product.productID,
            Customer: product.productName,
            TotalIssued: product.brandName,
            TotalRedeemed: product.supplierName,
            Balance:
              product.retailPrice != undefined
                ? parseFloat(product.retailPrice).toFixed(
                    getDefaultDecimalPlaces
                  )
                : '0.00'
          }
        })

        //  mapped.sort((a, b) => (a.productName > b.productName ? 1 : -1));
        setProductListingData(mapped)
        setIsLoading(false)
        // ;
        if (types.data.data.length > 0) {
          let paginationobj = {
            CurrentPageNo: types.data.data[0].currentPageNo,
            PageSize: types.data.data[0].pageSize,
            total: types.data.data[0].totalRecords
          }
          setPagination(paginationobj)
        }
      }
    })
  }

  const handleTableChange = (pagination, filters, sorter) => {
    var searchObj = searchFilterData
    searchObj.CurrentPageNo = pagination.current
    searchObj.PageSize = pagination.pageSize
    setSearchFilterData(searchObj)
    getProductListing(searchObj)
  }

  const handleSearch = async value => {
    if (value.length > 1) {
      let nameArray = []
      let searchProducts = {
        data: {
          msgCode: '',
          msgDescription: ''
        }
      }
      await ds
        .getBookSearchProd(`?keys=${value}`)
        .then(response => (searchProducts.data = response.data))
        .catch(e => {
          // console.log("Product Search Issue", e)
        })

      if (searchProducts.data.msgCode == 'GENERAL_SUCCESS') {
        if (searchProducts.data.data.length > 0) {
          setSearchProd(getSearchProd.concat(searchProducts.data.data))
          nameArray = searchProducts.data.data.map(names => {
            const category = names.productName
            return {
              value: category,
              label: (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between'
                  }}
                >
                  <span
                    style={{
                      backgroundColor: 'lightcyan',
                      fontStyle: 'oblique',
                      fontWeight: 'bolder'
                    }}
                  >
                    <a>{category}</a>
                  </span>
                  <span>
                    <IntlMessages id='products.addeditpriceprod.searchresult' />
                  </span>
                </div>
              )
            }
          })
        }
        setOptions(nameArray)
      }

      if (searchProducts.data.msgCode == 'GENERAL_ERROR') {
        message.error(searchProducts.data.msgDescription)
      }
    } else {
      setOptions([])
      setSearchProd([])
    }
  }
  const onSelect = value => {}

  const columns = [
    {
      title: <IntlMessages id='reporting.giftcardreports.giftcardnumber' />,
      dataIndex: 'Customer',
      key: 'Customer'
    },
    {
      title: <IntlMessages id='reporting.giftcardreports.totalsold' />,
      dataIndex: 'TotalSold',
      key: 'TotalSold'
    },
    {
      title: <IntlMessages id='reporting.giftcardreports.totalredeeemed' />,
      dataIndex: 'TotalRedeemed',
      key: 'TotalRedeemed'
    },
    {
      title: <IntlMessages id='reporting.giftcardreports.balance' />,
      dataIndex: 'Balance',
      key: 'Balance'
    }
  ]
  const onFinish = value => {
    let productTags =
      value.ProductTags &&
      value.ProductTags.map(obj => {
        return {
          key: obj.toString()
        }
      })

    var searchObj = {
      ProductSearchText: value.ProductSearch,
      ProductTags: productTags,
      Status: value.ProductStatus,
      BrandID: value.BrandID,
      SupplierID: value.SupplierID,
      ProductType: value.ProductType,
      CurrentPageNo: searchFilterData.CurrentPageNo,
      PageSize: searchFilterData.PageSize
    }
    setSearchFilterData(searchObj)
    getProductListing(searchObj)
  }

  function onDateChange (date, dateString) {
    //;
    //console.log(date, dateString);
  }

  const GiftCardReportTable = () => {
    return (
      <>
        <div className='gx-main-content-wrapper'>
          {isLoading ? (
            <Skeleton count={5} height={30} />
          ) : (
            <>
              <Table
                className='gx-table-responsive'
                columns={columns}
                dataSource={getProductListingData}
                onChange={handleTableChange}
              />
            </>
          )}
        </div>
      </>
    )
  }

  //Main Return
  return isFeatureAllowed ? (
    <div>
      <div className='custom-content-wrapper'>
        <Row>
          <Col md={24}>
            <h1 className=''>
              <IntlMessages id='reporting.giftcardreports.giftcardreports' />
            </h1>
          </Col>
        </Row>
        <Card
          className='gx-card custom-font-weight-500'
          style={{ marginTop: '20px' }}
          title={<IntlMessages id='products.main.add.searchfilters' />}
        >
          <Form
            {...formItemLayout}
            form={form}
            name={'SearchForm'}
            className='ant-advanced-search-form product-search-form'
            layout='horizontal'
            onFinish={onFinish}
            initialValues={{ ProductStatus: 1 }}
          >
            <>
              <Row>
                <Col
                  md={12}
                  lg={12}
                  sm={12}
                  xs={24}
                  style={{ display: 'block' }}
                >
                  <Form.Item
                    className='ant-form-item-label-custom ant-form-custom-alignment'
                    name='ProductSearch'
                    label={
                      <IntlMessages id='reporting.salesreport.filterreportby' />
                    }
                  >
                    <AutoComplete
                      className='certain-category-search'
                      dropdownClassName='certain-category-search-dropdown'
                      dropdownMatchSelectWidth={true}
                      allowClear={true}
                      autoFocus={true}
                      notFoundContent={
                        <IntlMessages id='products.addeditpriceprod.noprodfound' />
                      }
                      options={options}
                      onSelect={onSelect}
                      onSearch={handleSearch}
                    >
                      <Input
                        size='large'
                        placeholder='Add a filter...'
                        prefix={<i className='icon icon-search' />}
                      />
                    </AutoComplete>
                  </Form.Item>
                </Col>
                <Col
                  md={12}
                  lg={12}
                  sm={12}
                  xs={24}
                  style={{ display: 'block' }}
                >
                  <Form.Item
                    className='ant-form-item-label-custom ant-form-custom-alignment'
                    name='ProductSearch'
                  >
                    <div style={{ textAlign: 'right', marginBottom: '16px' }}>
                      <Button
                        className='custom-btn-addbtn'
                        type='primary'
                        size='large'
                      >
                        <IntlMessages id='reporting.giftcardreports.applyfilter' />
                      </Button>
                    </div>
                  </Form.Item>
                </Col>
              </Row>
            </>
          </Form>
        </Card>
        <Row gutter={[16, 16]} className='dk-mg-lf-rt-0'>
          <Col span={12}>
            <Row>
              <Col md={12}>
                <h2>
                  <strong>
                    <IntlMessages id='reporting.giftcardreports.totalvaluedissued' />
                  </strong>
                </h2>
              </Col>
              <Col md={12}>
                <h3>
                  {' '}
                  {getCurrData.currencyCode != null
                    ? getCurrData.currencyCode
                    : getCurrData.currencyName != null
                    ? getCurrData.currencyName
                    : getCurrData.currencySymbol}{' '}
                  0.00
                </h3>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            {' '}
            <Row>
              <Col md={12}>
                <h2>
                  <strong>
                    <IntlMessages id='reporting.giftcardreports.totalvalueredeemed' />
                  </strong>
                </h2>
              </Col>
              <Col md={12}>
                <h3>
                  {' '}
                  {getCurrData.currencyCode != null
                    ? getCurrData.currencyCode
                    : getCurrData.currencyName != null
                    ? getCurrData.currencyName
                    : getCurrData.currencySymbol}{' '}
                  0.00
                </h3>
              </Col>
            </Row>
          </Col>
          <Divider />
          <Col span={12}>
            <Row>
              <Col md={12}>
                <h2>
                  <strong>
                    <IntlMessages id='reporting.giftcardreports.outstandingbalance' />
                  </strong>
                </h2>
              </Col>
              <Col md={12}>
                <h3>
                  {' '}
                  {getCurrData.currencyCode != null
                    ? getCurrData.currencyCode
                    : getCurrData.currencyName != null
                    ? getCurrData.currencyName
                    : getCurrData.currencySymbol}{' '}
                  0.00
                </h3>
              </Col>
            </Row>
          </Col>
          <Col span={12}></Col>
        </Row>
      </div>

      <GiftCardReportTable />
    </div>
  ) : (
    <NotAllowedComponent
      getAccessLoading={false}
      textType={!isFeatureAllowed ? 2 : 1}
    />
  )
}

export default GiftCardReportsListing
